import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#005f9e'
    },
    background: {
      default: '#d8d8d8'
    }
  }
});
export default theme;
